import React from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import { GradientDecorationLine, BaseCustomButton, BaseSelectComponent, sampleMode } from '../../../shared';

export const GeneralInfoFormTab = ({
    labareas,
    labsegments,
    coordinations,
    customers,
    users,
    unitMeasures,
    kinds,
    locations,
    regions,
    sampleCount,
    setSampleCount,
    setActiveTab,
    formikFormData,
    resetFormAndCloseModal,
    isButtonDisabled,
    validateAndProceedToNextTab,
    isUpdate,
    mode,
    rowInfo,
    setInitialSampleDate
}) => {

    const handleSampleCountChange = (e) => {
        setSampleCount(e.target.value);
    }


    const handleSampleCountBlur = () => {
        setSampleCount((prevValue) => (Number(prevValue) > 0 ? Number(prevValue) : 1));
    };

    const handleSelectChange = (field, selectedValue) => formikFormData.setFieldValue(field, selectedValue);

    const handleDateAtChange = (e) => {
        formikFormData.setFieldValue("dateAt", e.target.value);
        setInitialSampleDate(e.target.value); // This triggers the update for all sample dates
    };

    return (
        <div>
            <Form className="form-horizontal mb-5">
                <div className='row mx-4'>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 mt-3">
                        <label className='text-primary ml-1'>Fecha de Muestreo</label>
                        <Input
                            required
                            name="dateAt"
                            className="form-control text-primary"
                            type='date'
                            {...formikFormData.getFieldProps("dateAt")}
                            onChange={handleDateAtChange} // Update this to call handleDateAtChange
                            invalid={formikFormData.touched.dateAt && !!formikFormData.errors.dateAt}
                        />
                        {formikFormData.touched.dateAt && formikFormData.errors.dateAt ? (
                            <FormFeedback type="invalid">{formikFormData.errors.dateAt}</FormFeedback>
                        ) : null}
                    </div>
                    {mode === sampleMode.sample && ( // Only show these fields in sample mode
                        <>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 mt-3">
                                <label className='text-primary ml-1'>Fecha de Recepción</label>
                                <Input
                                    required
                                    name="receivedAt"
                                    className="form-control text-primary"
                                    type='date'
                                    {...formikFormData.getFieldProps("receivedAt")}
                                    invalid={formikFormData.touched.receivedAt && !!formikFormData.errors.receivedAt}
                                />
                                {formikFormData.touched.receivedAt && formikFormData.errors.receivedAt ? (
                                    <FormFeedback type="invalid">{formikFormData.errors.receivedAt}</FormFeedback>
                                ) : null}
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 mt-3">
                                <label className='text-primary ml-1'>Fecha de Desecho</label>
                                <Input
                                    required
                                    name="wastedAt"
                                    className="form-control text-primary"
                                    type='date'
                                    {...formikFormData.getFieldProps("wastedAt")}
                                    invalid={formikFormData.touched.wastedAt && !!formikFormData.errors.wastedAt}
                                />
                                {formikFormData.touched.wastedAt && formikFormData.errors.wastedAt ? (
                                    <FormFeedback type="invalid">{formikFormData.errors.wastedAt}</FormFeedback>
                                ) : null}
                            </div>
                        </>
                    )}
                    {mode === sampleMode.labRequest && ( // Only show these fields in labRequest mode
                        <>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 mt-3">
                                <label className='text-primary ml-1'>Recepción Estimada</label>
                                <Input
                                    required
                                    name="estimateReceivedAt"
                                    className="form-control text-primary"
                                    type='date'
                                    {...formikFormData.getFieldProps("estimateReceivedAt")}
                                    invalid={formikFormData.touched.estimateReceivedAt && !!formikFormData.errors.estimateReceivedAt}
                                />
                                {formikFormData.touched.estimateReceivedAt && formikFormData.errors.estimateReceivedAt ? (
                                    <FormFeedback type="invalid">{formikFormData.errors.estimateReceivedAt}</FormFeedback>
                                ) : null}
                            </div>
                        </>
                    )}
                    <div className={`col-12 ${mode === sampleMode.sample ? "col-sm-6 col-md-6 col-lg-6 col-xl-3" : "col-sm-6 col-md-6 col-lg-6 col-xl-3"} mt-3`}>
                        <label className='text-primary ml-1'>Número de Muestras</label>
                        <Input
                            required
                            name="sampleCount"
                            className="form-control text-primary"
                            type="number"
                            min="1"
                            value={sampleCount}
                            onChange={handleSampleCountChange}
                            onBlur={handleSampleCountBlur}
                            invalid={formikFormData.touched.sampleCount && formikFormData.errors.sampleCount}
                            disabled={isUpdate}
                            onFocus={(e) => e.target.select()}
                        />
                        {formikFormData.touched.sampleCount && formikFormData.errors.sampleCount ? (
                            <FormFeedback type="invalid">{formikFormData.errors.sampleCount}</FormFeedback>
                        ) : null}
                    </div>
                    {mode === sampleMode.sample && ( // Only show these fields in sample mode
                        <>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 mt-3">
                                <label className='text-primary ml-1'>Área de Laboratorios</label>
                                <BaseSelectComponent
                                    options={labareas.map(dir => ({ value: dir.id, label: dir.name }))}
                                    value={formikFormData.values.laboratoryArea}
                                    onChange={(value) => handleSelectChange("laboratoryArea", value)}
                                    placeholder="Seleccione Área de Laboratorio"
                                    error="Seleccione Área de Laboratorio"
                                    touched={formikFormData.errors.laboratoryArea}
                                    status={formikFormData.errors.laboratoryArea ? 'error' : ''}
                                />
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 mt-3">
                                <label className='text-primary ml-1'>Segmento</label>
                                <BaseSelectComponent
                                    options={labsegments.map(dir => ({ value: dir.id, label: dir.name }))}
                                    value={formikFormData.values.laboratorySegment}
                                    onChange={(value) => handleSelectChange("laboratorySegment", value)}
                                    placeholder="Seleccione Segmento"
                                    error="Seleccione Segmento"
                                    touched={formikFormData.errors.laboratorySegment}
                                    status={formikFormData.errors.laboratorySegment ? 'error' : ''}
                                />
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 mt-3">
                                <label className='text-primary ml-1'>Coordinación</label>
                                <BaseSelectComponent
                                    options={coordinations.map(dir => ({ value: dir.id, label: dir.name }))}
                                    value={formikFormData.values.coordination}
                                    onChange={(value) => handleSelectChange("coordination", value)}
                                    placeholder="Seleccione Coordinación"
                                    error="Seleccione Coordinación"
                                    touched={formikFormData.errors.coordination}
                                    status={formikFormData.errors.coordination ? 'error' : ''}
                                />
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 mt-3">
                                <label className='text-primary ml-1'>Cliente/Proveedor</label>
                                <BaseSelectComponent
                                    options={customers.map(dir => ({ value: dir.id, label: dir.name }))}
                                    value={formikFormData.values.customer}
                                    onChange={(value) => handleSelectChange("customer", value)}
                                    placeholder="Seleccione Cliente/Proveedor"
                                    error="Seleccione Cliente/Proveedor"
                                    touched={formikFormData.errors.customer}
                                    status={formikFormData.errors.customer ? 'error' : ''}
                                />
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 mt-3">
                                <label className='text-primary ml-1'>Remitente/ Asesor Técnico</label>
                                <BaseSelectComponent
                                    options={users.filter(x => x.userType === 'Asesor Técnico').map(dir => ({ value: dir.id, label: `${dir.name} ${dir.surname}` }))}
                                    value={formikFormData.values.senderUser}
                                    onChange={(value) => handleSelectChange("senderUser", value)}
                                    placeholder="Seleccione Remitente"
                                    error="Seleccione Remitente"
                                    touched={formikFormData.errors.senderUser}
                                    status={formikFormData.errors.senderUser ? 'error' : ''}
                                />
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 mt-3">
                                <label className='text-primary ml-1'>Usuario que recibe</label>
                                <BaseSelectComponent
                                    options={users.filter(x => x.userType === 'Operativo').map(dir => ({ value: dir.id, label: `${dir.name} ${dir.surname}` }))}
                                    value={formikFormData.values.receiverUser}
                                    onChange={(value) => handleSelectChange("receiverUser", value)}
                                    placeholder="Seleccione Usuario que recibe"
                                    error="Seleccione Usuario que recibe"
                                    touched={formikFormData.errors.receiverUser}
                                    status={formikFormData.errors.receiverUser ? 'error' : ''}
                                />
                            </div>
                        </>)
                    }
                    <div className={`col-12 ${mode === sampleMode.sample ? "col-sm-6 col-md-6 col-lg-6 col-xl-4" : "col-sm-12 col-md-6 col-lg-6 col-xl-3"} mt-3`}>
                        <label className='text-primary ml-1'>Unidad de Medida</label>
                        <BaseSelectComponent
                            options={unitMeasures.map(dir => ({ value: dir.id, label: dir.name }))}
                            value={formikFormData.values.unitMeasure}
                            onChange={(value) => handleSelectChange("unitMeasure", value)}
                            placeholder="Seleccione Unidad de Medida"
                            error="Seleccione Unidad de Medida"
                            touched={formikFormData.errors.unitMeasure}
                            status={formikFormData.errors.unitMeasure ? 'error' : ''}
                        />
                    </div>
                    {mode === sampleMode.labRequest && isUpdate ? ( // Only show these fields in labRequest mode and isUpdate
                        <>
                            <div className="col-12 col-sm-12 col-md-6 mt-3">
                                <label className='text-primary ml-1'>Cliente/Proveedor</label>
                                <Input
                                    disabled={true}
                                    name="customer"
                                    className="form-control text-primary"
                                    placeholder="Cliente"
                                    onChange={formikFormData.handleChange}
                                    onBlur={formikFormData.handleBlur}
                                    value={isUpdate ? rowInfo.labRequest?.customer?.name ?? '' : ''}
                                />
                            </div>
                            <div className="col-12 col-md-6 mt-3">
                                <label className='text-primary ml-1'>Asesor Técnico</label>
                                <Input
                                    disabled={true}
                                    name="technicalAdviser"
                                    className="form-control text-primary"
                                    placeholder="Asesor Técnico"
                                    onChange={formikFormData.handleChange}
                                    onBlur={formikFormData.handleBlur}
                                    value={isUpdate ? rowInfo.labRequest?.technicalAdviser?.name ?? '' : ''}
                                />
                            </div>
                        </>
                    ) : null}
                    <div className={`col-12 col-sm-6 col-md-4 col-lg-4 mt-3`}>
                        <label className='text-primary'>Cantidad</label>
                        <Input
                            required
                            name="quantity"
                            className="form-control text-primary"
                            placeholder="Cantidad"
                            type="number"
                            min="0"
                            {...formikFormData.getFieldProps("quantity")}
                            invalid={formikFormData.touched.quantity && !!formikFormData.errors.quantity}
                            onFocus={(e) => e.target.select()}
                        />
                        {formikFormData.touched.quantity && formikFormData.errors.quantity ? (
                            <FormFeedback type="invalid">{formikFormData.errors.quantity}</FormFeedback>
                        ) : null}
                    </div>
                    <div className={`col-12 col-sm-6 col-md-4 col-lg-4 mt-3`}>
                        <label className='text-primary ml-1'>Clase</label>
                        <BaseSelectComponent
                            options={kinds.map(dir => ({ value: dir.id, label: dir.name }))}
                            value={formikFormData.values.kind}
                            onChange={(value) => handleSelectChange("kind", value)}
                            placeholder="Seleccione Clase"
                            error="Seleccione Clase"
                            touched={formikFormData.errors.kind}
                            status={formikFormData.errors.kind ? 'error' : ''}
                        />
                    </div>
                    <div className={`col-12 col-sm-6 col-md-4 col-lg-4 mt-3`}>
                        <label className='text-primary ml-1'>Localidad</label>
                        <BaseSelectComponent
                            options={regions.map(dir => ({ value: dir.id, label: `${dir.state}-${dir.municipality}` }))}
                            value={formikFormData.values.region}
                            onChange={(value) => handleSelectChange("region", value)}
                            placeholder="Seleccione Localidad"
                            error="Seleccione Localidad"
                            touched={formikFormData.errors.region}
                            status={formikFormData.errors.region ? 'error' : ''}
                        />
                    </div>
                </div>
                {/* Campo Región oculto: preservado para compatibilidad con datos históricos */}
                <div style={{ display: 'none' }}>
                    <BaseSelectComponent
                        options={locations.map(dir => ({ value: dir.id, label: dir.name }))}
                        value={formikFormData.values.location}
                        onChange={(value) => handleSelectChange("location", value)}
                    />
                </div>
                <div className="row mx-4">
                    <div className="col-12 mt-3">
                        <label className='text-primary'>Observaciones</label>
                        <Input
                            required
                            name="observations"
                            className="form-control text-primary"
                            placeholder="Observaciones"
                            type="textarea"
                            {...formikFormData.getFieldProps("observations")}
                            invalid={formikFormData.touched.observations && !!formikFormData.errors.observations}
                        />
                        {formikFormData.touched.observations && formikFormData.errors.observations ? (
                            <FormFeedback type="invalid">{formikFormData.errors.observations}</FormFeedback>
                        ) : null}
                    </div>
                </div>

            </Form>
            <GradientDecorationLine />

            <div className="d-flex justify-content-end mt-4 mx-4">
                <BaseCustomButton
                    label='Siguiente'
                    className={`rounded-3 me-3 ${isButtonDisabled ? "btn-dark disabled" : "btn-success"}`}
                    icon='mdi mdi-arrow-right me-2'
                    onClick={() => validateAndProceedToNextTab(setActiveTab)}
                />
                <BaseCustomButton
                    outline
                    label='Cancelar'
                    color="danger"
                    className="rounded-3"
                    icon='mdi mdi-close-circle-outline me-2'
                    onClick={resetFormAndCloseModal}
                />
            </div>
        </div>
    );
};
